/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { CalendarCenterSupplier } from './CalendarCenterSupplier';
import {
    CalendarCenterSupplierFromJSON,
    CalendarCenterSupplierFromJSONTyped,
    CalendarCenterSupplierToJSON,
    CalendarCenterSupplierToJSONTyped,
} from './CalendarCenterSupplier';

/**
 * 
 * @export
 * @interface ResponseCalendarCenterSupplier
 */
export interface ResponseCalendarCenterSupplier {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseCalendarCenterSupplier
     */
    result: ResponseResult;
    /**
     * 
     * @type {CalendarCenterSupplier}
     * @memberof ResponseCalendarCenterSupplier
     */
    data: CalendarCenterSupplier;
}

/**
 * Check if a given object implements the ResponseCalendarCenterSupplier interface.
 */
export function instanceOfResponseCalendarCenterSupplier(value: object): value is ResponseCalendarCenterSupplier {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseCalendarCenterSupplierFromJSON(json: any): ResponseCalendarCenterSupplier {
    return ResponseCalendarCenterSupplierFromJSONTyped(json, false);
}

export function ResponseCalendarCenterSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCalendarCenterSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': CalendarCenterSupplierFromJSON(json['data']),
    };
}

export function ResponseCalendarCenterSupplierToJSON(json: any): ResponseCalendarCenterSupplier {
    return ResponseCalendarCenterSupplierToJSONTyped(json, false);
}

export function ResponseCalendarCenterSupplierToJSONTyped(value?: ResponseCalendarCenterSupplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': CalendarCenterSupplierToJSON(value['data']),
    };
}

